module.exports = __webpack_public_path__ + "img/bh_24.a465a411.jpg";